export enum CategoryType {


  BullDozer = 1,
  Tractor = 2,
  PaddyCombineHarvesterWheelType = 3,
  BackhoeWithFrontendLeveler = 4,
  CrawlerExcavator = 5,
  MaizeCombineHarvester = 6,
  SugarcaneHarvesterAndInfielders = 7,
  TruckOperatedCoconutHoist = 8,
  RotaryDrill = 9,
  PercussionDrill = 10,
  MiniDrill = 11,
  MobileServiceUnit = 12,
  PaddyMobileDryer = 13,
  AirCompressor = 14,
  MultiAxleCarrier = 15,
  CarrierVehicleForCombineHarvester = 16,
  HandBoringSets = 17,
  RockBlastingUnit = 18,
  AcResistivityMeter = 19,
  ElectricalLogger = 20,
  PaddyCombineHarvesterTrackType = 21,
  MiniTractor = 22,
  TractorforSugarcaneInfielder = 23,
  PowerWeeder = 24,
  PowerTiller = 25,
  PaddyTransplanter = 26,
  Drone = 27,
  BrushCutter = 28,
  TeaHarvester = 29,
  MiniBackhoeWithFrontendLeveler = 30
}
